const comments = [
  {
    name: '漫画迷小枫',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20cute%20anime%20style%20avatar%20portrait%20with%20warm%20colors%2C%20minimal%20style%2C%20soft%20lighting%2C%20clean%20background&width=100&height=100&seq=avatar-01&orientation=squarish',
    manga: '我独自升级',
    text: '追了三年终于等到完结！土豪漫画网的更新速度真的没话说，每天蹲点刷新已经是生活的一部分了。韩漫推荐板块每次都精准命中我的口味！',
    time: '2小时前',
    rating: 5,
  },
  {
    name: '二次元老司机',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20cute%20anime%20style%20avatar%20portrait%20with%20warm%20colors%2C%20minimal%20style%2C%20soft%20lighting%2C%20clean%20background&width=100&height=100&seq=avatar-02&orientation=squarish',
    manga: '神之塔',
    text: '日漫大全的整理太专业了，按年份和类型分类非常清晰。推荐给我身边的朋友都在用，好看的漫画真的太多了根本看不过来！',
    time: '5小时前',
    rating: 5,
  },
  {
    name: '追更小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20cute%20anime%20style%20avatar%20portrait%20with%20warm%20colors%2C%20minimal%20style%2C%20soft%20lighting%2C%20clean%20background&width=100&height=100&seq=avatar-03&orientation=squarish',
    manga: '斗破苍穹',
    text: '国漫排行榜给了我很多惊喜，以前只知道日漫，现在发现国漫也这么好看。分类漫画功能让找漫效率提高了太多！',
    time: '8小时前',
    rating: 4,
  },
  {
    name: '深夜读书人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20cute%20anime%20style%20avatar%20portrait%20with%20warm%20colors%2C%20minimal%20style%2C%20soft%20lighting%2C%20clean%20background&width=100&height=100&seq=avatar-04&orientation=squarish',
    manga: '全知读者视角',
    text: '每天睡前必刷的一个站，漫画分类做得特别细，悬疑推理区挖到好多宝藏漫画。土豪漫画网真的是漫画爱好者的天堂！',
    time: '12小时前',
    rating: 5,
  },
  {
    name: '热血漫铁粉',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20cute%20anime%20style%20avatar%20portrait%20with%20warm%20colors%2C%20minimal%20style%2C%20soft%20lighting%2C%20clean%20background&width=100&height=100&seq=avatar-05&orientation=squarish',
    manga: '咒术回战',
    text: '从韩漫看到日漫再到国漫，土豪漫画网陪我度过了无数个无聊的夜晚。漫画大全名副其实，分类精准从不踩雷！',
    time: '1天前',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">读者热评</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            听听漫画爱好者们的真实声音，看看大家都在追哪些<strong>好看的漫画</strong>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.slice(0, 3).map((c) => (
            <div key={c.name} className="p-5 bg-background-50 border border-background-200/60 rounded-xl">
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={c.avatar}
                  alt={c.name}
                  className="w-10 h-10 rounded-full object-cover bg-background-200"
                  loading="lazy"
                />
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-500">在读《{c.manga}》</div>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: c.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{c.text}</p>
              <span className="text-xs text-foreground-400">{c.time}</span>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {comments.slice(3).map((c) => (
            <div key={c.name} className="p-5 bg-background-50 border border-background-200/60 rounded-xl">
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={c.avatar}
                  alt={c.name}
                  className="w-10 h-10 rounded-full object-cover bg-background-200"
                  loading="lazy"
                />
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-500">在读《{c.manga}》</div>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: c.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{c.text}</p>
              <span className="text-xs text-foreground-400">{c.time}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}